import { useDisplay } from 'vuetify';
import type { Ref } from 'vue';

// `xs` is phone-only (width < 640px); `smAndDown` would include tablets up to 1024px.
export function useIsMobilePhone(): Ref<boolean> {
  return useDisplay().xs;
}
